import { render } from "./DisplayField.vue?vue&type=template&id=4bffe710&scoped=true&ts=true"
import script from "./DisplayField.vue?vue&type=script&lang=ts"
export * from "./DisplayField.vue?vue&type=script&lang=ts"

import "./DisplayField.vue?vue&type=style&index=0&id=4bffe710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bffe710"]])

export default __exports__